import { ProductDetail } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';

const ProductCardShortDescriptor = ({ shortDescriptors }) => (
  <ProductDetail variant="small">
    {shortDescriptors.join(' | ')}
  </ProductDetail>
);

ProductCardShortDescriptor.propTypes = {
  shortDescriptors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProductCardShortDescriptor;
